import { useId } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTitle } from 'components/Dialog';
import { Button, DialogActions, DialogContentText } from '@mui/material';
import { usePageReload } from 'hooks/usePageReload';

type Cause = 'connection_failed' | 'network_blocked';
type Direction = 'publishing' | 'subscribing';

const MediaConnectionFailedModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();
  const modalId = useId();
  const modalData = useAppSelector(selectActiveModalData);
  const { createReloadUrl } = usePageReload();

  const cause: Cause = (modalData.cause as Cause) ?? 'connection_failed';
  const direction: Direction = (modalData.direction as Direction) ?? 'subscribing';

  const hideModal = () => dispatch(closeModal('mediaConnectionFailed'));

  return (
    <Dialog
      open
      aria-labelledby={`${modalId}-title`}
      aria-describedby={`${modalId}-description`}
      onClose={hideModal}
      maxWidth="xs"
    >
      <DialogTitle id={`${modalId}-title`} onClose={hideModal}>
        {t(`media_connection_failure.${direction}.${cause}.title`)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={`${modalId}-description`}>
          {t(`media_connection_failure.${direction}.${cause}.description`)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {cause === 'network_blocked' ? (
          <Button type="button" onClick={hideModal} color="grayscale">
            {t('media_connection_failure.btn_close_label')}
          </Button>
        ) : (
          <Button
            type="button"
            href={createReloadUrl()}
            onClick={(e) => {
              e.preventDefault();
              window.location.replace(createReloadUrl());
            }}
          >
            {t('media_connection_failure.btn_rejoin_label')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MediaConnectionFailedModal;
